// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Paging = require("../../../../shared/src/Paging.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var DateUtils = require("../../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebTypes_View = require("../../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebTypes_Shift = require("../../types/WebTypes_Shift.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Loading = require("../../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var WebComponents_DashboardShiftsList = require("../../components/WebComponents_DashboardShiftsList.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.padding2(BrowserStyle.zero, BrowserStyle.Spacing.medium),
      tl: /* [] */0
    });

var image = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(7.0)),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.width(BrowserStyle.rem(5.75)),
              tl: {
                hd: BrowserStyle.height(BrowserStyle.rem(5.75)),
                tl: /* [] */0
              }
            }),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.rem(7.0)),
          tl: /* [] */0
        }
      }
    });

var phoneImage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(7.75)),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.width(BrowserStyle.rem(6.5)),
              tl: {
                hd: BrowserStyle.height(BrowserStyle.rem(6.5)),
                tl: /* [] */0
              }
            }),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.rem(7.75)),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  container: container,
  image: image,
  phoneImage: phoneImage
};

function WebContainers_BusinessDashboard_Shifts$Presentation$NoShiftsCTA$CTAImage(Props) {
  var className = Props.className;
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: BrowserStyle.Utils.extendBaseStyle(container, className),
              children: null
            }, React.createElement(BrowserComponents_Image.make, {
                  className: image,
                  image: {
                    TAG: /* Illustration */1,
                    _0: /* Professionals */73
                  }
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement(BrowserComponents_Image.make, {
                  className: phoneImage,
                  image: {
                    TAG: /* Illustration */1,
                    _0: /* PhoneTouch */70
                  }
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement(BrowserComponents_Image.make, {
                  className: image,
                  image: {
                    TAG: /* Illustration */1,
                    _0: /* FoodBeverageBuilding */33
                  }
                }));
}

var CTAImage = {
  Styles: Styles,
  make: WebContainers_BusinessDashboard_Shifts$Presentation$NoShiftsCTA$CTAImage
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.vw(100.0)),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
          tl: {
            hd: BrowserStyle.flexGrow(1.0),
            tl: {
              hd: BrowserStyle.overflowY(BrowserStyle.scroll),
              tl: /* [] */0
            }
          }
        }
      }
    });

var ctaContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.textAlign("center"),
      tl: {
        hd: BrowserStyle.alignItems("center"),
        tl: {
          hd: BrowserStyle.display("flex"),
          tl: {
            hd: BrowserStyle.justifyContent("spaceAround"),
            tl: {
              hd: BrowserStyle.flexDirection("column"),
              tl: {
                hd: BrowserStyle.width(BrowserStyle.pct(33.0)),
                tl: {
                  hd: BrowserStyle.marginTop(BrowserStyle.rem(4.1875)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.flexDirection("column"),
        tl: {
          hd: BrowserStyle.alignItems("center"),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.vw(100.0)),
            tl: {
              hd: BrowserStyle.flexGrow(1.0),
              tl: /* [] */0
            }
          }
        }
      }
    });

var shiftCardContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.pct(45.0)),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.width(BrowserStyle.pct(95.0)),
                tl: /* [] */0
              }),
          tl: {
            hd: BrowserStyle.marginLeft("auto"),
            tl: {
              hd: BrowserStyle.marginRight("auto"),
              tl: {
                hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.small),
                tl: {
                  hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.small),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var postAShiftButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
      tl: {
        hd: BrowserStyle.marginTop(BrowserStyle.rem(2.0)),
        tl: /* [] */0
      }
    });

var mainText = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginTop(BrowserStyle.rem(1.125)),
      tl: /* [] */0
    });

var heck = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexGrow(1.1),
      tl: /* [] */0
    });

var Styles$1 = {
  container: container$1,
  ctaContainer: ctaContainer,
  content: content,
  shiftCardContainer: shiftCardContainer,
  postAShiftButton: postAShiftButton,
  mainText: mainText,
  heck: heck
};

function WebContainers_BusinessDashboard_Shifts$Presentation$NoShiftsCTA(Props) {
  var instruction = Props.instruction;
  var setView = Props.setView;
  var title = Props.title;
  return React.createElement("div", {
              className: container$1
            }, React.createElement("section", {
                  className: content
                }, React.createElement("div", {
                      className: Curry._1(Css.merge, {
                            hd: shiftCardContainer,
                            tl: {
                              hd: ctaContainer,
                              tl: /* [] */0
                            }
                          })
                    }, React.createElement("h3", undefined, React.createElement(ReactUtils.S.make, {
                              children: title
                            })), React.createElement("p", {
                          className: mainText
                        }, React.createElement(ReactUtils.S.make, {
                              children: instruction
                            })), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* XLarge */6
                        }), React.createElement(WebContainers_BusinessDashboard_Shifts$Presentation$NoShiftsCTA$CTAImage, {}), React.createElement(BrowserComponents_Button.make, {
                          actionPriority: /* Primary */0,
                          className: postAShiftButton,
                          iconLeft: {
                            TAG: /* Shift */6,
                            _0: /* SelectArea */18
                          },
                          onClick: (function (param) {
                              return Curry._1(setView, {
                                          TAG: /* PostAShift */4,
                                          _0: undefined
                                        });
                            }),
                          title: "Post a Shift"
                        }), React.createElement("div", {
                          className: heck
                        }))));
}

var NoShiftsCTA = {
  CTAImage: CTAImage,
  Styles: Styles$1,
  make: WebContainers_BusinessDashboard_Shifts$Presentation$NoShiftsCTA
};

var container$2 = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.display("flex"),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.flexDirection(BrowserStyle.row),
              tl: {
                hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.minHeight(BrowserStyle.zero),
                    tl: {
                      hd: BrowserStyle.mobileMedia({
                            hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                            tl: /* [] */0
                          }),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }));

var Styles$2 = {
  container: container$2
};

function WebContainers_BusinessDashboard_Shifts$Presentation(Props) {
  var currentDatetime = Props.currentDatetime;
  var currentShiftsListView = Props.currentShiftsListView;
  var fetchShifts = Props.fetchShifts;
  var items = Props.items;
  var loadMoreShifts = Props.loadMoreShifts;
  var onCancel = Props.onCancel;
  var onComment = Props.onComment;
  var onCopy = Props.onCopy;
  var onReviewWorker = Props.onReviewWorker;
  var responsiveLayout = Props.responsiveLayout;
  var setView = Props.setView;
  var totalNumberOfShifts = Props.totalNumberOfShifts;
  var param = Props.user;
  var timezone = param.city.timezone;
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          if (typeof param === "number" && param === 0) {
            return fetchShifts;
          } else {
            return Relude_IO.pure(undefined);
          }
        }), items);
  var partial_arg = React.createElement("div", undefined, React.createElement(ReactUtils.S.make, {
            children: "An error occurred."
          }));
  return React.createElement("main", {
              className: container$2
            }, Relude_AsyncResult.foldByValue(React.createElement(BrowserComponents_Loading.$$Screen.make, {}), (function (items) {
                    if (items.length !== 0) {
                      return React.createElement(WebComponents_DashboardShiftsList.make, {
                                  currentDatetime: currentDatetime,
                                  currentShiftsListView: currentShiftsListView,
                                  items: items,
                                  loadMoreShifts: loadMoreShifts,
                                  onCancel: onCancel,
                                  onComment: onComment,
                                  onCopy: onCopy,
                                  onReviewWorker: onReviewWorker,
                                  responsiveLayout: responsiveLayout,
                                  setView: setView,
                                  timezone: timezone
                                });
                    }
                    var match = Relude_Int.eq(0, totalNumberOfShifts);
                    return React.createElement(WebContainers_BusinessDashboard_Shifts$Presentation$NoShiftsCTA, {
                                instruction: match ? (
                                    currentShiftsListView ? "In order to start seeing your upcoming shifts, you need to post your first shift!" : "As soon as your first shift is completed, you'll see it here. Post it now!"
                                  ) : (
                                    currentShiftsListView ? "You don't have any upcoming shift at the moment. Post a shift to change that!" : "You'll start seeing your past shifts once they've been completed. Got another shift to post? Click the button below"
                                  ),
                                setView: setView,
                                title: currentShiftsListView ? "Let's get this party started." : "Check back soon!"
                              });
                  }), (function (param) {
                    return Relude_Globals.$$const(partial_arg, param);
                  }), items));
}

var Presentation = {
  NoShiftsCTA: NoShiftsCTA,
  Styles: Styles$2,
  make: WebContainers_BusinessDashboard_Shifts$Presentation
};

function getShiftDateGroup(param) {
  return DateUtils.getJsDateInForcedTimezone(param.timezone)(DateUtils.getDateWithoutTime(param.startDatetime));
}

var compare = DateUtils.compare(undefined, undefined);

function eq(param, param$1) {
  return DateUtils.eq(undefined, undefined, param, param$1);
}

var DateMap = Relude_Map.WithOrd({
      eq: eq,
      compare: compare
    });

function getcurrentViewAsyncResult(currentView) {
  return Reselect.createSelector2(undefined, (function (param) {
                return param.dashboard.pastPageMarker;
              }), (function (param) {
                return param.dashboard.upcomingPageMarker;
              }), (function (pastPageMarker, upcomingPageMarker) {
                if (currentView) {
                  return upcomingPageMarker;
                } else {
                  return pastPageMarker;
                }
              }));
}

function getcurrentViewAsyncResult$1(currentView) {
  return Reselect.createSelector1(Relude_AsyncResult.eqBy((function (prim, prim$1) {
                    return prim === prim$1;
                  }), (function (prim, prim$1) {
                    return prim === prim$1;
                  })), getcurrentViewAsyncResult(currentView), (function (param) {
                return Relude_AsyncResult.map((function (prim) {
                              
                            }), param);
              }));
}

function getSortedAndFilteredItems(currentView) {
  return Reselect.createSelector2((function (param, param$1) {
                return Relude_Array.eqBy(WebComponents_DashboardShiftsList.ListItem.eq, param, param$1);
              }), WebStore_Selectors.getTimeEveryHour, (function (param) {
                return param.dashboard.shifts;
              }), (function (currentDatetime) {
                var partial_arg = Curry._1(Relude_Array.map, (function (param) {
                        return Relude_Array.prepend(WebComponents_DashboardShiftsList.ListItem.timestamp(param[0]), Curry._2(Relude_Array.map, WebComponents_DashboardShiftsList.ListItem.shift, param[1]));
                      }));
                var partial_arg$1 = Curry._1(DateMap.map, (function (param) {
                        return Relude_Array.sortBy((function (param, param$1) {
                                      return Curry._2(DateUtils.compare(undefined, /* Minute */2), param.startDatetime, param$1.startDatetime);
                                    }), param);
                      }));
                var partial_arg$2 = Curry._1(DateMap.groupArrayBy, (function (param) {
                        var arg = Caml_option.some(param.timezone);
                        return DateUtils.roundDateToResolution(undefined, /* Day */4, arg)(param.startDatetime);
                      }));
                var partial_arg$3 = currentView ? (function (param) {
                      return Relude_Array.filter((function (param) {
                                    if (param.cancelledAt !== undefined) {
                                      return false;
                                    } else {
                                      return DateUtils.isGreaterThanOrEqualTo(undefined, undefined, currentDatetime)(param.endDatetime);
                                    }
                                  }), param);
                    }) : (function (param) {
                      return Relude_Array.filter((function (param) {
                                    if (param.cancelledAt !== undefined) {
                                      return true;
                                    } else {
                                      return DateUtils.isBefore(undefined, undefined, currentDatetime)(param.endDatetime);
                                    }
                                  }), param);
                    });
                var partial_arg$4 = function (param) {
                  return Relude_Globals.$great$great(WebTypes_Shift.$$Set.toArray, partial_arg$3, param);
                };
                var partial_arg$5 = function (param) {
                  return Relude_Globals.$great$great(partial_arg$4, partial_arg$2, param);
                };
                var partial_arg$6 = function (param) {
                  return Relude_Globals.$great$great(partial_arg$5, partial_arg$1, param);
                };
                var partial_arg$7 = function (param) {
                  return Relude_Globals.$great$great(partial_arg$6, DateMap.toArray, param);
                };
                var partial_arg$8 = function (param) {
                  return Relude_Globals.$great$great(partial_arg$7, (function (param) {
                                return Relude_Array.sortBy((function (param, param$1) {
                                              var b = param$1[0];
                                              var a = param[0];
                                              if (currentView) {
                                                return Curry._2(DateUtils.compare(undefined, /* Minute */2), a, b);
                                              } else {
                                                return Curry._2(DateUtils.compare(undefined, /* Minute */2), b, a);
                                              }
                                            }), param);
                              }), param);
                };
                var partial_arg$9 = function (param) {
                  return Relude_Globals.$great$great(partial_arg$8, partial_arg, param);
                };
                return function (param) {
                  return Relude_Globals.$great$great(partial_arg$9, Relude_Array.flatten, param);
                };
              }));
}

function getCurrentViewAsyncResultItems(currentView) {
  return Reselect.createSelector2(Relude_AsyncResult.eqBy((function (prim, prim$1) {
                    return prim === prim$1;
                  }), (function (prim, prim$1) {
                    return prim === prim$1;
                  })), getSortedAndFilteredItems(currentView), getcurrentViewAsyncResult$1(currentView), (function (param) {
                return Relude_Globals.$great$great(Relude_Globals.$$const, Relude_AsyncResult.map, param);
              }));
}

var Selectors = {
  getcurrentViewAsyncResult: getcurrentViewAsyncResult$1,
  getSortedAndFilteredItems: getSortedAndFilteredItems,
  getCurrentViewAsyncResultItems: getCurrentViewAsyncResultItems
};

function mapStateToProps(currentShiftsListView) {
  return Reselect.createSelector4(undefined, WebStore_Selectors.getTimeEveryFiveMinutes, getCurrentViewAsyncResultItems(currentShiftsListView), (function (param) {
                return param.layout;
              }), (function (param) {
                return param.dashboard.shifts;
              }), (function (currentDatetime, items, layout, shifts) {
                return {
                        currentDatetime: currentDatetime,
                        items: items,
                        responsiveLayout: layout,
                        totalNumberOfShifts: Relude_Set.length(shifts)
                      };
              }));
}

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$2 = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg_fetchShifts = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.fetchShifts)));
  var partial_arg_loadMoreShifts = function (currentlyShowingIndex) {
    var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
            
          }));
    var arg = Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.fetchShifts));
    var partial_arg$1 = function (eta) {
      return Paging.loadMoreItems(undefined, arg, currentlyShowingIndex)(eta);
    };
    var partial_arg$2 = function (param) {
      return Relude_Globals.$great$great((function (param) {
                    return Relude_Globals.$great$great(Relude_Array.length, Relude_AsyncResult.completeOk, param);
                  }), partial_arg$1, param);
    };
    return function (param) {
      return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
    };
  };
  var partial_arg_onCancel = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (param) {
                                return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.cancelShift, WebStore_Types_Action.dashboard, param);
                              }), dispatch, param);
                }), partial_arg, param);
  };
  var partial_arg_onComment = function (s, c) {
    return Curry._2(Relude_IO.mapError, (function (prim) {
                  
                }), Curry._1(dispatch, WebStore_Types_Action.commentOnShift(s, c)));
  };
  var partial_arg_onCopy = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (param) {
                                return Relude_Globals.$great$great((function (param) {
                                              return Relude_Globals.$great$great(Relude_Option.pure, WebTypes_View.postAShift, param);
                                            }), WebStore_Types_Action.setView, param);
                              }), dispatch, param);
                }), partial_arg$1, param);
  };
  var partial_arg_onReviewWorker = function (param, rating) {
    return Curry._2(Relude_IO.mapError, (function (prim) {
                  
                }), Curry._1(dispatch, WebStore_Types_Action.reviewWorker(param.id, rating)));
  };
  var partial_arg_setView = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                }), partial_arg$2, param);
  };
  var partial_arg$3 = {
    fetchShifts: partial_arg_fetchShifts,
    loadMoreShifts: partial_arg_loadMoreShifts,
    onCancel: partial_arg_onCancel,
    onComment: partial_arg_onComment,
    onCopy: partial_arg_onCopy,
    onReviewWorker: partial_arg_onReviewWorker,
    setView: partial_arg_setView
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$3, param);
  };
}

function WebContainers_BusinessDashboard_Shifts(Props) {
  var currentShiftsListView = Props.currentShiftsListView;
  var user = Props.user;
  var mapStateToProps$1 = ReactIO.useMemo1(mapStateToProps, currentShiftsListView);
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps$1,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_BusinessDashboard_Shifts$Presentation, {
                              currentDatetime: param.currentDatetime,
                              currentShiftsListView: currentShiftsListView,
                              fetchShifts: param$1.fetchShifts,
                              items: param.items,
                              loadMoreShifts: param$1.loadMoreShifts,
                              onCancel: param$1.onCancel,
                              onComment: param$1.onComment,
                              onCopy: param$1.onCopy,
                              onReviewWorker: param$1.onReviewWorker,
                              responsiveLayout: param.responsiveLayout,
                              setView: param$1.setView,
                              totalNumberOfShifts: param.totalNumberOfShifts,
                              user: user
                            });
                })
            });
}

var make = WebContainers_BusinessDashboard_Shifts;

exports.Presentation = Presentation;
exports.getShiftDateGroup = getShiftDateGroup;
exports.DateMap = DateMap;
exports.Selectors = Selectors;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* container Not a pure module */
